angular.module('zc.zenclerkS')
  .factory('ZcsCampaign', ZcsCampaign);

ZcsCampaign.$inject = ['$filter', '$uibModal', 'Campaign', 'Devise', 'Environment', 'ZcsCampaignName'];
function ZcsCampaign($filter, $uibModal, Campaign, Devise, Environment, ZcsCampaignName) {
  const FIST_DATA_DAY = '2016-12-01';
  const service = {
    FIST_DATA_DAY,
    openMailMagUrlModal,
    save,
    getCampaignProgress,
    getTooltipMessage,
    isAllowedLiteTemplate,
    isAllowedToCreate,
    isCampaignEndingSoon,
  };

  return service;

  function prepareCampaignObject(campaign) {
    let campaignObject = _.merge({}, campaign);

    if(campaignObject.id === 'new') {
      campaignObject.id = undefined;
    }

    // Handle date generation manually so that we can use them for name
    // generation below
    campaignObject.start_at = $filter('dateObjToDate')(campaignObject.start_at_obj);
    campaignObject.end_at = $filter('dateObjToDate')(campaignObject.end_at_obj);

    campaignObject.name = ZcsCampaignName.getCampaignName(campaignObject);

    return campaignObject;
  }

  function getCampaignProgress(campaign) {
    const timeUnitsInJapanese = {
      days: '日',
      hours: '時間',
      minutes: '分',
    };

    const campaignProgress = {
      progress: 0,
      progressUnit: 'days',
      progressLeft: 0,
      toString: () => '残り' + campaignProgress.progressLeft + _.get(timeUnitsInJapanese, campaignProgress.progressUnit),
    };

    if(campaign.current_status === 'terminated') {
      return _.merge(campaignProgress, {
        progress: 100,
      });
    }

    if(moment(campaign.end_at).diff(moment(), 'hours') < 24) {
      _.merge(campaignProgress, {
        progressUnit: 'hours',
      });
    }

    if(moment(campaign.end_at).diff(moment(), 'minutes') < 60) {
      _.merge(campaignProgress, {
        progressUnit: 'minutes',
      });
    }

    const timeDifference = moment().diff(moment(campaign.start_at), campaignProgress.progressUnit) + 1;
    if(timeDifference < 0) {
      return campaignProgress;
    }

    const duration = moment(campaign.end_at).diff(moment(campaign.start_at), campaignProgress.progressUnit) + 1;
    _.merge(campaignProgress, {
      progress: Math.max(0, Math.min(100, 100 * (timeDifference / duration))),
      progressLeft: duration - timeDifference
    });

    return campaignProgress;
  }

  function getTooltipMessage(project) {
    if(masterUserCreatingACouponForMakeshopAgencyInProdEnv(project)) {
      return $filter('translate')('services.campaign.notAllowedAccessMaster', { env: Environment.environment });
    }

    if(!project.pricing_confirmed_at) {
      return $filter('translate')('services.campaign.notAllowedAccessPricing');
    }

    if(project.suspended_at) {
      return $filter('translate')('services.campaign.notAllowedCampaignDisabled');
    }
  }

  function isCampaignEndingSoon(campaign) {
    if(!campaign) return false;

    const DAY_LIMIT = 14;
    const campaignProgress = getCampaignProgress(campaign);

    if(_.includes(['hours', 'minutes'], campaignProgress.progressUnit)) {
      return true;
    }

    return campaignProgress.progressLeft < DAY_LIMIT;
  }

  function isAllowedToCreate(project) {
    if(!project) return false;

    if(masterUserCreatingACouponForMakeshopAgencyInProdEnv(project)) {
      return false;
    }

    if(project.suspended_at) {
      return false;
    }

    // TODO: remove on 2017-05         ###START###
    // makerepeater should create normally
    if(project.is_oem) {
      return true;
    } else if(moment().isAfter(moment('2017-04-01')) && !project.pricing_confirmed_at) {
      return false;
    }
    // TODO: remove on 2017-05         ###END###
    return true;
  }

  function masterUserCreatingACouponForMakeshopAgencyInProdEnv(project) {
    const isPreProdOrProdEnv = _.includes(['preprod', 'production'], Environment.environment);
    const isMakeshopAgency = project.is_oem && project.shopping_cart_asp === 'makeshop';
    const isMasterUser = Devise.currentUser && Devise.isMaster();
    const isATestSite = project.is_test;
    // Allow only our makeshop test site to create campaigns
    const isOurTestSite = project.apikey === 'test-6c17db893ab972ed';

    return isPreProdOrProdEnv && isMakeshopAgency && isMasterUser && !isATestSite && !isOurTestSite;
  }

  function save(campaign, project) {
    campaign.isSaving = true;
    const campaignObject = prepareCampaignObject(campaign);

    let promise;
    if(campaign.id === 'new') {
      promise = Campaign.createFromParams({projectId: project.id}, { campaign: campaignObject, element: campaignObject.element });
    } else {
      promise = Campaign.update({projectId: project.id, campaignId: campaign.id}, campaignObject);
    }
    promise.finally(() => { campaign.isSaving = false });

    return promise;
  }

  function openMailMagUrlModal(campaign, project) {
    $uibModal.open({
      templateUrl: '/templates/zenclerk_s/sites/campaigns/mail_mag_url_modal.html',
      openedClass: 'shows-all-url-content',
      controllerAs: '$ctrl',
      controller: 'ZcsMailMagUrlModalController',
      resolve: {
        campaign: campaign,
        project: project
      }
    });
  }

  function isAllowedLiteTemplate(campaign, project) {
    const allowedTemplates = ['zcs_textonly', 'zcs_image', 'giftcard'];
    if(project.region !== 'asia_tokyo') {
      allowedTemplates.shift();
    }
    if(_.includes(allowedTemplates, campaign.template_type)) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/campaign.service.js